export enum RESTSERVICE {
  SUCCESSFUL = 'Successful',
  RECORD_UPDATED = 'Record Updated',
  RECORD_UPDATE_ERROR = 'Error Updating Record',
  RECORD_CREATE_ERROR = 'Error Adding Record',
  RECORD_DELETE_ERROR = 'Error Deleting Record',
  SUCCESS = 'success',
  ERROR = 'error',
  ERRORTITLE = 'Error Message',
  CREATED = 'Created',
  RECORD_DELETED = 'Record Deleted',
  RECORDS_DELETED = 'Records Deleted',
  UPLOADED_SUCCESS = 'Uploaded Successfully',
  SAVED = 'Saved Successfully',
  DELETED = 'Deleted Successfully',
  WARN = 'warn',
  WARNING = 'Warning',
  INVALID_FORM = 'Details are Null/Invalid',
}
